import { Breadcrumbs as MuiBreadcrumbs } from '@mui/material';

import { Skeleton } from 'shared/components/Skeleton';

import { Breadcrumb } from './components/Breadcrumb';
import { BREADCRUMBS_TEST_ID, MAX_ITEMS } from './constants';
import { useBreadcrumbs, useMaxItems } from './hooks';

import type { FC } from 'react';

export const Breadcrumbs: FC = () => {
  const breadcrumbs = useBreadcrumbs();
  const maxItems = useMaxItems(MAX_ITEMS);

  return (
    <MuiBreadcrumbs maxItems={maxItems} data-testid={BREADCRUMBS_TEST_ID}>
      {breadcrumbs.map(({ title, to, isLoading }) =>
        isLoading ? (
          <Skeleton key={title} width={120} height={12} />
        ) : (
          <Breadcrumb key={title} title={title} to={to} />
        ),
      )}
    </MuiBreadcrumbs>
  );
};
